import React, { useState } from 'react';
import { CarTypeCarousel } from '../components/CarTypeCarousel';
import { CarListingGrid } from '../components/CarListingGrid';
interface CatalogPageProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export function CatalogPage({
  searchQuery,
  setSearchQuery
}: CatalogPageProps) {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  return <>
      <div className="max-w-[1600px] mx-auto flex" data-id="element-285" data-mp="2dntpj7a44jqg">
        <main className="flex-1 p-4 md:p-6 lg:p-8 min-w-0" data-id="element-286" data-mp="2dqeqzv6i0xno">
          <h1 className="text-2xl font-bold text-[#F2F0E9] mb-6" data-id="element-287" data-mp="29obcsysg3eyp">Catálogo</h1>

          <CarTypeCarousel selectedType={selectedType} onSelectType={setSelectedType} data-id="element-288" data-mp="2nn19wef9len2" />
          <CarListingGrid searchQuery={searchQuery} selectedType={selectedType} data-id="element-289" data-mp="2imwuysu08ryy" />
        </main>
      </div>
    </>;
}